import { City } from "./city.model";

export interface IUserZone{
  id ?: number;
  name ?: string;
  city ?: City;
  username ?: string;
  disabled ?: boolean;
}

export class UserZone implements IUserZone{
  constructor(
    public id?: number,
    public name?: string,
    public city ?: City,
    public username ?: string,
    public disabled ?: boolean,
  ){
    this.id = id;
    this.name = name;
    this.city = city;
    this.username = username;
    this.disabled = disabled;
  }

}
